import { registerRouter } from "@lib/router";
import type { QueryClient } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "../routeTree.gen";
import { AuthProvider } from "./components/AuthProvider";
import { Providers } from "./providers";

interface AppProps {
  queryClient: QueryClient;
}

function App({ queryClient }: AppProps) {
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    context: {
      queryClient,
      auth: undefined,
    },
  });

  // Expose the router to non-React code (Mercure handlers navigate via router.navigate)
  registerRouter(router);

  return (
    <Providers>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </Providers>
  );
}

export default App;
